import React from "react";
import {Link} from "react-router-dom";
import FlexBox from "view/components/Layout/FlexBox";
import FFairLogo from "view/images/FFairLogo";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import {green, red} from "@material-ui/core/colors";
import {Button} from "@mui/material";
import useStyles from "./styles";

type NoAccessWrapperProps = {
  children: React.ReactNode;
  showCloseButton?: boolean;
};

export function NoAccessWrapper({
  children,
  showCloseButton,
}: NoAccessWrapperProps) {
  const classes = useStyles();
  return (
    <FlexBox width="100vw" height="100vh" column alignCenter justifyCenter>
      <FlexBox className={classes.noAccessWrapper} column gap={2} alignCenter>
        <FFairLogo width={64} height={64} />
        <span className={classes.ffairLogoText}>FFAIR</span>
        {children}
        {showCloseButton && (
          <Link to="/">
            <Button color="primary" variant="contained" fullWidth={false}>
              Close
            </Button>
          </Link>
        )}
      </FlexBox>
    </FlexBox>
  );
}

export function ExpiredLink() {
  const classes = useStyles();
  return (
    <NoAccessWrapper showCloseButton>
      <FlexBox gap={1} alignCenter>
        <CancelIcon htmlColor={red[500]} />
        <span className={classes.noLongerValidMessage}>
          This payment link is no longer valid.
        </span>
      </FlexBox>
      <span className={classes.commonText}>
        The order has already been paid or the link has expired.
        <br />
        <br />
        Please contact the supplier for assistance.
      </span>
    </NoAccessWrapper>
  );
}

export function AlreadyPaid() {
  const classes = useStyles();
  return (
    <NoAccessWrapper showCloseButton>
      <FlexBox gap={1} alignCenter>
        <CheckCircleIcon htmlColor={green[500]} />
        <span className={classes.noLongerValidMessage}>
          Payment successful.
        </span>
      </FlexBox>
      <span className={classes.commonText}>
        This order has already been paid. Thank you!
      </span>
    </NoAccessWrapper>
  );
}

export function WrongUserRole() {
  const classes = useStyles();
  return (
    <NoAccessWrapper showCloseButton>
      <span className={classes.wrongUserRole}>
        You must be logged in as an Exhibitor to complete this payment.
      </span>
      <span className={classes.commonText}>
        Please log in with your Exhibitor account or contact the supplier for
        access.
      </span>
    </NoAccessWrapper>
  );
}

export function WrongExhibitor() {
  const classes = useStyles();
  return (
    <NoAccessWrapper showCloseButton>
      <FlexBox gap={1} alignCenter>
        <CancelIcon htmlColor={red[500]} />
        <span className={classes.noLongerValidMessage}>
          This payment link is invalid.
        </span>
      </FlexBox>
      <span className={classes.commonText}>
        Please contact the supplier for assistance.
      </span>
    </NoAccessWrapper>
  );
}

export function InvalidUrl() {
  const classes = useStyles();
  return (
    <NoAccessWrapper showCloseButton>
      <FlexBox gap={1} alignCenter>
        <CancelIcon htmlColor={red[500]} />
        <span className={classes.noLongerValidMessage}>
          This payment link is no longer valid.
        </span>
      </FlexBox>
    </NoAccessWrapper>
  );
}
